<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/lp/20230104-0331eco_set_headder.jpg" class="only_pc" />
        <img src="@/assets/img/lp/20230104-0331eco_set_headder.jpg" class="only_sp" />
      </div>
    </div>
    <P class="mt-5 p-3 pc_text-center">
      一人ひとりの小さな想いを、美しい未来へ。<br class="only_pc">マナビス エコプロジェクト、いよいよスタートします。<br class="only_pc">まずはリユースボトル＆リフィルから。
    </p>
    <div class="special_sec_btn mt-5 p-3">
      <ul>
        <li>
          <a class="" @click="scrollToAnchorPoint('reuseDetail')">
            <img src="@/assets/img/reuse/reuseDetail.jpeg" alt="リユースボトルとリフィルについて">
          </a>
        </li>
        <li>
          <a class="" @click="scrollToAnchorPoint('ecoset')">
            <img src="@/assets/img/reuse/ecoset.jpeg" alt="期間限定エコ仕様発売記念セット">
          </a>
        </li>
        <li>
          <a class="" @click="scrollToAnchorPoint('ecoprojectDetail')">
            <img src="@/assets/img/reuse/ecoprojectDetail.jpeg" alt="マナビスエコプロジェクトとは">
          </a>
        </li>
      </ul>
    </div>
  </section>
    
  <section class="sec-cmn-02 section_top" ref="reuseDetail">
    <div class="list-lineup">
      <h4 class="ttl-top-01">リユースボトルとリフィルについて</h4>
    </div>
    <div class="box-work-01">
      <div class="box-work-in">
        <figure class="type-02"><div v-on:click="openInfo('1')"><img src="@/assets/img/reuse/bottle_refill.jpg" alt=""></div><div v-on:click="openInfo('2')"><img class="mt-5" src="@/assets/img/reuse/bottle_refill_2.jpg" alt=""></div></figure>
        <p class="txt-work-01">リユースボトルとリフィルは別売りです。まずはセットでお求めになり、ご使用後は、リフィルのみをリピート購入してください。ご愛用品が一目でわかるよう、アイテムごとに色分けしてあります。</p>
        <p class="txt-work-01">このセットには、エコ・簡単・清潔のすべてを叶えるClean Clic® System（クリーン・クリック・システム）を採用。製品のコンパクト化やリユースが、プラスチックの削減へつながります。お使いになる際は、ディスペンサーに真空パウチのコネクターを取り付けるだけ。こぼしてしまう心配もありません。また、使い終わるまで真空状態が保たれるため、変質や異物・雑菌の侵入を抑えることもできます。</p>
        <p class="txt-work-01" style="font-size: 12px;">※Clean Clic® System（クリーンクリックシステム）は、株式会社昭和丸筒がオランダIPN B.V.社と日本国内ライセンス契約している登録商標です。</p>
      </div>
    </div>
    <section class="mt-5">
            <div class="box-iframe-01">
              <iframe src="https://www.youtube.com/embed/le-JQizUmZY" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
            </div>
          </section>
  </section>

  <section class="sec-cmn-02 section_top" ref="ecoset">
    <div class="list-lineup">
      <h4 class="ttl-top-01">期間限定エコ仕様発売記念セット</h4>
    </div>
    <section class="sec-product">
      <figure class="img-product"><router-link to="/products"><img src="@/assets/img/reuse/restorejel_ecoset.jpg" alt="薬用レストアジェルエコ仕様発売記念セット"></router-link></figure>
      <div class="box-product">
        <h2 class="name fc-b">薬用レストアジェル<br>エコ仕様発売記念セット</h2>
        <p class="detail">マナビス&nbsp;薬用レストアジェル（リフィル・つめかえ用）&nbsp;33g×2</p>
        <p class="detail">マナビス&nbsp;薬用レストアジェル（リユースボトル・空ボトル）&nbsp;×1</p>
        <p class="price">2022年12月30日（金）〜2023年3月31日（金）期間限定<br><span class="fc-b fs-15">リユースボトルプレゼント<br>ポイント付与3倍</span></p>
        <p class="price">商品番号&nbsp;450<br>¥&nbsp;10,500（税込）<br>実績数&nbsp;2</p>
      </div>
    </section>
    <section class="sec-product">
      <figure class="img-product"><router-link to="/products"><img src="@/assets/img/reuse/moisturejel_ecoset.jpg" alt="モイスチャージェルエコ仕様発売記念セット"></router-link></figure>
      <div class="box-product">
        <h2 class="name fc-b">モイスチャージェル<br>エコ仕様発売記念セット</h2>
        <p class="detail">マナビス&nbsp;モイスチャージェル（リフィル・つめかえ用）&nbsp;33g×2</p>
        <p class="detail">マナビス&nbsp;モイスチャージェル（リユースボトル・空ボトル）&nbsp;×1</p>
        <p class="price">2022年12月30日（金）〜2023年3月31日（金）期間限定<br><span class="fc-b fs-15">リユースボトルプレゼント<br>ポイント付与3倍</span></p>
        <p class="price">商品番号&nbsp;451<br>¥&nbsp;10,500（税込）<br>実績数&nbsp;2</p>
      </div>
    </section>
  </section>

  <section class="sec-cmn-03 section_top" ref="ecoprojectDetail">
    <div class="list-lineup">
      <h4 class="ttl-top-01">マナビス エコプロジェクトとは</h4>
    </div>
    <div class="box-work-01">
      <div class="box-work-in">
        <p class="mb-5">地球も美肌に。</p>
        <p class="txt-work-01">この想いを胸に、マナビスグループの一人ひとりがエコプロジェクトに携わっています。毎日使う化粧品が肌にやさしいものであるように、その容器が地球の負担になってはいけない。未来のために今できることは？試行錯誤のなか生まれたのがリユースボトル＆リフィル、そして、専用ボトル＆つめかえ用。プラスチック削減への小さな一歩です。次は、お使いくださる一人ひとりへ想いを託します。以前からご愛用になっている方は新しい容器に戸惑われるかもしれませんが、どうぞ、美しい未来へのバトンをつないでいただけますように。</p>
      </div>
    </div>
  </section>

  <!-- モーダル -->
  <div class="modal-container" v-on:click="closeInfo('0')" :class="{'is-active': isActive[0]}">
    <div class="modal-body">
      <div class="modal-close">×</div>
      <div class="modal-content">
        <figure>
        <img src="@/assets/img/reuse/keyvisual.jpg" alt="マナビス エコプロジェクト">
        </figure>
      </div>
    </div>
  </div>
  <!-- モーダル -->
  <div class="modal-container" v-on:click="closeInfo('1')" :class="{'is-active': isActive[1]}">
    <div class="modal-body">
      <div class="modal-close">×</div>
      <div class="modal-content">
        <figure>
        <img src="@/assets/img/reuse/bottle_refill.jpg" alt="リユースボトルとリフィル">
        </figure>
      </div>
    </div>
  </div>
  <!-- モーダル -->
  <div class="modal-container" v-on:click="closeInfo('2')" :class="{'is-active': isActive[2]}">
    <div class="modal-body">
      <div class="modal-close">×</div>
      <div class="modal-content">
        <figure>
        <img src="@/assets/img/reuse/bottle_refill_2.jpg" alt="リユースボトルとリフィル">
        </figure>
      </div>
    </div>
  </div>

  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<!-- 化粧品公式サイトのスタイルを反映 -->
<style src="../../assets/css/custom.css" scoped>
</style>
<style src="../../assets/css/module.css" scoped>
</style>
<style src="../../assets/css/module_sp.css" scoped>
</style>
<style src="../../assets/css/top.css" scoped>
</style>

<style scoped>
.section_top {
  padding-top: 30px;
}
.banner-btn-02.special_sec_btn {
  margin-top: 0px;
  padding: 5px;
}
.special_sec_btn {
  flex-direction: initial;
  align-items: initial;
}
.special_sec_btn {
  cursor: pointer;
}
.special_sec_btn ul li {
  display: inline-block;
  width: 100%;
  padding: 5px;
}
.special_sec_btn ul li img {
  border: 1px solid #eee;
}
.pc_text-center {
  text-align: center;
}
@media (min-width: 768px) {
  .special_sec_btn ul li {
    width: 33%;
  }
}
.conversion_erea .banner-btn-02 {
  margin-top: 10px;
  flex-direction: inherit;
}
.conversion_erea .banner-btn-02 a {
  font-size: 2rem;
}
button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}
.section_top .list-lineup {
  margin-bottom: 30px;
}
.box-product .name {
  text-align: left;
  font-size: 20px;
}
.list-detail dt::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 13px;
  display: block;
  width: 14px;
  height: 14px;
  margin-top: -7px;
  background: url(../../assets/img/flora_anniversary/ico_arrow.svg) no-repeat;
  background-size: contain;
  transition: transform 0.2s;
}
.list-detail dt {
  font-size: inherit;
}
.list-qa dt {
  padding: 12px 40px 12px 35px !important;
}

.list-detail dd {
  display:block;
}


.list-detail .list-qa dd:first-of-type {
    display: block;
}
.set .box-product .name {
  font-size: 22px;
}
.fc-b {
  color: #000;
}
.fs-15 {
  font-size: 1.5em;
}
.box-top-slide {
  height: auto;
}


.box-iframe-01 {
  height: 449px;
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .pc_text-center {
    text-align: left;
  }
  .box-iframe-01 {
    height: 210px;
  }
}

/*モーダル本体の指定 + モーダル外側の背景の指定*/
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background: rgba(0,0,0,50%);
  padding: 40px 20px;
  overflow: auto;
  opacity: 0;
  visibility: hidden;
  transition: .3s;
  box-sizing: border-box;
  z-index: 1;
}
/*モーダル本体の擬似要素の指定*/
.modal-container:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}
/*モーダル本体に「active」クラス付与した時のスタイル*/
.modal-container.is-active {
  opacity: 1;
  visibility: visible;
}
/*モーダル枠の指定*/
.modal-body {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 90%;
}
/*モーダルを閉じるボタンの指定*/
.modal-close {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: -40px;
  right: -40px;
  width: 40px;
  height: 40px;
  font-size: 40px;
  color: #fff;
  cursor: pointer;
}
/*モーダル内のコンテンツの指定*/
.modal-content{
  background: #fff;
  text-align: left;
  padding: 5px;
}

.modal-open:hover,.modal-open2:hover,.modal-open3:hover {
    cursor: pointer;
}

</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
    window.scroll(0, 0);
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>